import { PowerBiObjectModel } from './../_models/DAL/PowerBiObject.model';
import { Component, OnInit} from '@angular/core';
import { ApiClhubService } from '../_services/apiClhub.service';
import { CommonTools } from '../_helpers/common.tools';

declare var $: any;

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css'],
})

export class AdminComponent implements OnInit {
  private GroupsEmbedded;

  public SelectedGroup;

  private loadingReportAndDashboard = true;
  public loadingGroups = true;

  public ReportsEmbedded:PowerBiObjectModel[];
  public ReportsNotInAzure:PowerBiObjectModel[];
  public DashboardsEmbedded:PowerBiObjectModel[];
  public DashboardsNotInAzure:PowerBiObjectModel[];

  isDashboardToEdit = false;

  editGroup: object;
  displayModelEdit = 'none';

  isReadOnly = false;
  /**delete confirm Modal */
  PBIOtoDelete: PowerBiObjectModel;
  showDeleteConfirmModal = false;

  constructor(private ApiClient: ApiClhubService) { }

  ngOnInit() {
    this.ApiClient.get('PowerBi/group-embedded').subscribe((result) => {
      this.GroupsEmbedded = result;
      this.loadingGroups = false;
    });

  }

  azureWorkspaceId: string = '';

  applySortByNamePBIO(pbios: PowerBiObjectModel[]) {
    pbios.sort((a, b) => CommonTools.BaseSortCb(a.customName, b.customName));
  }
  loadReportsAndDashoardsOfGroup(group) {
    this.loadingReportAndDashboard = true;
    this.azureWorkspaceId = group.id;
    this.SelectedGroup = group;
    this.ApiClient.get('PowerBi/report-by-group?groupId=' + group.id).subscribe(resultReports => {
      if (resultReports) {
        // ? who is this AzurObjectId 'b7623dc3-ac3c-4354-955f-826aaf92d2db'
        const reportToRemove = resultReports.filter(report => report.AzureObjectId === 'b7623dc3-ac3c-4354-955f-826aaf92d2db')[0];
        if (reportToRemove) {
          resultReports.splice(resultReports.indexOf(report => report.AzureObjectId === 'b7623dc3-ac3c-4354-955f-826aaf92d2db'), 1);
        }
      }
      this.ReportsEmbedded = resultReports;
      this.applySortByNamePBIO(this.ReportsEmbedded);


      this.loadReportsOfGroupNotInAzure(group);

    });

    this.ApiClient.get('PowerBi/dashboard-by-group?groupId=' + group.id).subscribe(resultDashboard => {
      this.DashboardsEmbedded = resultDashboard;
      this.applySortByNamePBIO(this.DashboardsEmbedded);
      this.loadDasboardsNotInAzure(group);
    });
  }

  loadReportsOfGroupNotInAzure(group) {
    this.ApiClient.get('PowerBi/getReportsNotInAzure?AzureWorkspaceId=' + group.id).subscribe(resultReports => {
      this.ReportsNotInAzure = resultReports;
      this.applySortByNamePBIO(this.ReportsNotInAzure);
      this.loadingReportAndDashboard = false;
    });
  }

  loadDasboardsNotInAzure(group) {
    this.ApiClient.get('PowerBi/getDashboardsNotInAzure?AzureWorkspaceId=' + group.id).subscribe(resultDashboards => {
      this.DashboardsNotInAzure = resultDashboards;
      this.applySortByNamePBIO(this.DashboardsNotInAzure);
      this.loadingReportAndDashboard = false;
    });
  }

  changeEditGroupObject(reportToEdit) {
    const reportObject = this.ReportsEmbedded.filter(report => report.azureObjectId === reportToEdit.azureObjectId)[0];
    this.editGroup = reportObject;
    this.isDashboardToEdit = false;
    this.isReadOnly = false;
    this.changeEditObjectModal({open:true,reload:false});
  }

  viewBIObject(objectToView: any, isDashbord: boolean) {
    this.editGroup = objectToView;
    this.isDashboardToEdit = isDashbord;
    this.isReadOnly = true;
    // console.log(JSON.stringify(objectToView))
    this.changeEditObjectModal({open:true,reload:false});
  }

  changeEditDashboardObject(object) {
    this.editGroup = this.DashboardsEmbedded.filter(dashboard => dashboard.azureObjectId === object.azureObjectId)[0];
    this.isDashboardToEdit = true;
    this.isReadOnly = false;
    this.changeEditObjectModal({open:true,reload:false});
  }

  changeEditObjectModal(event: ModalEventEmitter): void {

    if (event.open) {
      this.displayModelEdit = 'block';
    } else {
      this.displayModelEdit = 'none';
      this.editGroup = null;
    }
    if(event.reload)this.loadReportsAndDashoardsOfGroup(this.SelectedGroup);
  }



  deletePowerBiObject(object) {

    this.ApiClient.delete('PowerBIObject/' + object.id, null).subscribe(() => {

      if (object.isReport) {
        const index = this.ReportsNotInAzure.findIndex(obj => obj.id === object.id);
        this.ReportsNotInAzure.splice(index, 1);
      } else {
        const index = this.DashboardsNotInAzure.findIndex(obj => obj.id === object.id);
        this.DashboardsNotInAzure.splice(index, 1);
      }

    });
  }

  /**Confirm Modal : Removing roles */
  closeDeleteConfirmModal() {
    this.showDeleteConfirmModal = false;
    this.PBIOtoDelete = null;
  }
  openDeleteConfirmModal(value: PowerBiObjectModel) {
    this.PBIOtoDelete = value;
    this.showDeleteConfirmModal = true;
  }
  cancelDeletePBIO() { this.closeDeleteConfirmModal(); }
  confirmDeletePBIO() {
    this.deletePowerBiObject(this.PBIOtoDelete)
    this.closeDeleteConfirmModal();
  }



}
export interface ModalEventEmitter{
  open:boolean;
  reload:boolean;
}
